import { ListItemText, ListItemIcon } from '@mui/material';
import { styled } from '@mui/material/styles';

export const IconItemsList = styled(ListItemIcon)(({theme, active}) => ({
  display: 'flex',
  justifyContent: 'center',
  boxSizing: '1em',
  color: active === 'true' ? theme.iconMenuItem.iconActive : theme.iconMenuItem.icon,
  backgroundColor: theme.iconMenuItem.iconBackground
}));

export const FeatureTextItemsList = styled(ListItemText)(({theme}) => ({
  color: theme.accessibilityItems.colorLabel,
}));
